export default function createStepsPalette(theme, current, base) {
    return {
        steps: {
            content: {
                color: base.text[500],
                disabled: {
                    color: base.gray[500],
                },
            },
            tail: {
                backgroundColor: base.gray[200],
                finished: {
                    backgroundColor: current[500],
                },
            },
            dot: {
                color: current.contrast[500],
                backgroundColor: current[500],
                borderColor: "transparent",
                disabled: {
                    color: base.gray[500],
                    backgroundColor: "transparent",
                    borderColor: base.gray[200],
                },
                finished: {
                    color: current[500],
                    backgroundColor: current[50],
                    borderColor: "transparent",
                },
            },
        },
    };
}
//# sourceMappingURL=steps.js.map